import React from 'react';

function NotFound() {
    return ( 
    <div className='Container p-5 mb-5'>
            <div className='row text-center'>
                <h1 className='mt-5 fs-2' >404 NOT FOUND</h1>
                <p>Sorry the page you looking for does not exsist.</p>
              
            </div>
            
         </div>
 );
}

export default NotFound;